"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showAustralianCompliance = exports.AU_FUNDRAISING_COMPLIANCE = void 0;
const country_1 = require("../enums/country");
exports.AU_FUNDRAISING_COMPLIANCE = {
    version: "2026-05-12",
    locale: "en",
    text: "I confirm my organization is solely responsible for complying with Australian fundraising regulations, including obtaining required state registrations and permits (see our Terms and Australia Addendum).",
};
const showAustralianCompliance = (country) => {
    return country === country_1.OrganizationCountry.Australia;
};
exports.showAustralianCompliance = showAustralianCompliance;
